import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { theme } from "antd";
const KeyBenefit = ({ icon, heading, body })=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-keybenefit",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "rc-account-v2-keybenefit__icon",
                children: icon ?? /*#__PURE__*/ _jsx(CheckCircleFilled, {
                    style: {
                        color: token.colorSuccess
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-keybenefit__heading",
                        style: {
                            color: token.colorTextHeading
                        },
                        children: heading
                    }),
                    body && /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-keybenefit__body",
                        style: {
                            color: token.colorText
                        },
                        children: body
                    })
                ]
            })
        ]
    });
};
export { KeyBenefit };
